import { render, staticRenderFns } from "./AssignmentEntryItem.vue?vue&type=template&id=47206ca4&scoped=true"
import script from "./AssignmentEntryItem.vue?vue&type=script&lang=ts"
export * from "./AssignmentEntryItem.vue?vue&type=script&lang=ts"
import style0 from "./AssignmentEntryItem.vue?vue&type=style&index=0&id=47206ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47206ca4",
  null
  
)

export default component.exports